import { z } from 'zod';
export const REPLY_CLASSIFICATION_LABELS = [
    'interested',
    'meeting_request',
    'question',
    'not_now',
    'not_interested',
    'wrong_person',
    'unsubscribe',
    'other',
];
export const replyClassificationSchema = z.object({
    label: z.enum(REPLY_CLASSIFICATION_LABELS),
    confidence: z.number().min(0).max(1),
    follow_up_date: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .nullable(),
    referral_name: z.string().max(120).nullable(),
    referral_email: z.string().email().nullable(),
    reason: z.string().max(200),
});
export const REPLY_CLASSIFICATION_REVIEW_THRESHOLD = 0.7;
export const REPLY_CLASSIFICATION_SUPPRESS_NOT_INTERESTED_THRESHOLD = 0.85;
export const REPLY_CLASSIFICATION_PROMPT_VERSION = '2026-10-28.v1';
export const REPLY_CLASSIFICATION_LABEL_LABELS = {
    interested: 'Geïnteresseerd',
    meeting_request: 'Afspraak',
    question: 'Vraag',
    not_now: 'Later',
    not_interested: 'Geen interesse',
    wrong_person: 'Verkeerde persoon',
    unsubscribe: 'Uitschrijven',
    other: 'Onduidelijk',
};
//# sourceMappingURL=replyClassification.js.map